import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

import { Context } from '../context/DataContext';
import useDataGetter from '../hooks/useDataGetter';
import SelectField from '../components/form/SelectField';
import AutoCompleteField from '../components/form/AutoCompleteField'; // Adjust path if necessary

const SpecificationPage = () => {
  const navigate = useNavigate();
  const {
    setCustomerInfo,
    state: {
      loginInfo: { dealerNo },
    },
  } = React.useContext(Context);
  const {
    modelList = [],
    brandList = [],
    categoryList = [],
  } = useDataGetter(
    `${process.env.REACT_APP_LEAGUE_BASE_API_URL}/recins/SVCInsuranceBrandModelList${dealerNo}.json`,
    {}
  );
  const [errorMsg, setErrorMsg] = React.useState('');
  const [values, setValues] = React.useState({
    vendor: '',
    category: '',
    marketName: '',
    capacity: '',
  });
  const { vendor, capacity, marketName, category } = values;

  const handleChange = (prop) => (e) =>
    setValues({ ...values, [prop]: e.target.value });

  const marketNames = [
    ...new Set(
      modelList
        .filter(
          ({ brand, category: modelCategory }) =>
            brand === vendor && modelCategory === category
        )
        .map(({ marketName }) => marketName)
    ),
  ];

  const capacityList = [
    ...new Set(
      modelList
        .filter((obj) => obj.marketName === marketName)
        .map(({ capacity }) => capacity)
        .sort((a, b) => a - b)
    ),
  ];

  return (
    <Box>
      <Typography
        variant='h4'
        sx={{ my: 2 }}>
        手機規格
      </Typography>
      {modelList.length > 0 &&
      brandList.length > 0 &&
      categoryList.length > 0 ? (
        <Box
          component='form'
          sx={{ px: 3, '& > :not(style)': { my: 1 } }}
          noValidate
          autoComplete='off'>
          <SelectField
            fullWidth
            id='phone-vendor'
            label='廠牌'
            placeholder='請選擇...'
            value={vendor}
            onChange={(e) => {
              setValues({
                vendor: e.target.value,
                category: '',
                marketName: '',
                capacity: '',
              });
            }}
            options={brandList.map((brand, index) => ({
              id: `vendor_${index}`,
              value: brand,
              text: brand,
            }))}
            textAlign='left'
          />
          <SelectField
            fullWidth
            id='category'
            label='類別'
            placeholder='請選擇...'
            value={category}
            onChange={(e) => {
              setValues({
                vendor,
                category: e.target.value,
                marketName: '',
                capacity: '',
              });
            }}
            options={categoryList.map((category, index) => ({
              id: `category_${index}`,
              value: category,
              text: category,
            }))}
            textAlign='left'
          />
          <AutoCompleteField
            fullWidth
            name='marketName'
            label='型號'
            value={marketName}
            onChange={(event) => {
              setValues({
                vendor,
                category,
                marketName: event.target.value || '',
                capacity: '',
              });
            }}
            options={marketNames}
            noOptionsText='無符合的型號'
          />
          <SelectField
            fullWidth
            id='phone-capacity'
            label='容量'
            placeholder='請選擇...'
            value={capacity}
            onChange={handleChange('capacity')}
            options={capacityList.map((capacity, index) => ({
              id: `capacity_${index}`,
              value: capacity,
              text: `${capacity}GB`,
            }))}
            textAlign='left'
          />
          {errorMsg ? (
            <Typography
              variant='h6'
              sx={{ my: 2, color: 'red' }}>
              {errorMsg}
            </Typography>
          ) : null}
          <Button
            variant='contained'
            sx={{ width: 168 }}
            onClick={() => {
              if (!vendor || !marketName || !capacity) {
                setErrorMsg('請先選擇手機規格');
              } else {
                const { model, productType } = modelList.find(
                  (obj) =>
                    obj.marketName === marketName && obj.capacity === capacity
                );

                setCustomerInfo(
                  {
                    brand: vendor,
                    capacity,
                    market_n: marketName,
                    model,
                    productType,
                  },
                  () => {
                    navigate('/imei');
                  }
                );
              }
            }}>
            下一步
          </Button>
        </Box>
      ) : (
        <Typography
          variant='h5'
          sx={{ my: 2 }}>
          讀取規格清單中...
        </Typography>
      )}
    </Box>
  );
};

export default SpecificationPage;
